import * as React from 'react';

import { useListBillableMetrics } from 'src/features/billableMetrics/api/useListBillableMetrics';
import { BillableMetric } from 'src/features/billableMetrics/utils/types';

/**
 * `billable_metric` arrives as a bare UUID on every plan item and subscription item, so any screen
 * showing a metric name needs this lookup. One cached query, shared by all of them.
 *
 * The 500 ceiling is deliberate: metrics are operator-created configuration, not transactional data.
 * If a tenant ever exceeds it, this hook is the single place to paginate.
 */
export function useBillableMetricMap(): Map<string, BillableMetric> {
    const { data } = useListBillableMetrics({ limit: 500 });

    return React.useMemo(() => new Map((data?.results ?? []).map((metric) => [metric.id, metric])), [data]);
}
